function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M301.71,433a10,10,0,1,1,10-10A10,10,0,0,1,301.71,433Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,301.71,414.94Zm0,12.56a.91.91,0,1,1,.91-.91A.91.91,0,0,1,301.71,427.5Zm0-2.73a.91.91,0,0,1-.91-.91V418.5a.91.91,0,1,1,1.82,0v5.36A.91.91,0,0,1,301.71,424.77Z",
  transform: "translate(-291.71 -412.95)"
});

var SvgLogsFail = function SvgLogsFail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("span", {
    className: "svg_icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f37a71",
    fillRule: "evenodd",
    width: "20px",
    height: "20px",
    "data-name": "Logs faild Icon",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogsFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs_fail.bf518574.svg";
export { ForwardRef as ReactComponent };